<template>
  <v-select
          v-model="filter"
          id="category"
          :options="categories"
          label="name"
          :multiple="true"
          @input="filterTable"
  ></v-select>
</template>

<script>
import { mapActions } from 'vuex'
import { Event } from 'vue-tables-2'

export default {
  name: 'CategoryFilter',
  data:function () {
    return {
      filter: []
    }
  },
  mounted () {
    this.getCategories('/categories?itemsPerPage=500')
  },
  computed: {
    categories () {
      return this.$store.getters['category/list/items'] || []
    },
    data () {
      let ids = []

      this.filter.forEach(item => {
        ids.push(item.id)
      })

      return ids
    }
  },
  methods: {
    ...mapActions({
      getCategories: 'category/list/default'
    }),
    filterTable () {
      Event.$emit('vue-tables.filter::category.id', this.data)
    }
  }
}
</script>
